import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-text-edit-text-icon',
  templateUrl: './text-edit-text.component.html'
})
export class TextEditTextComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
